<div class="w-full">

  <!-- TITULOS -->
  <div class="flex justify-between mb-3">
    <span
      *ngFor="let step of steps; let i = index; let first = first; let last = last"
      class="text-sm cursor-pointer hover:text-westetics-purple-600 transition-colors"
      [ngClass]="{
        'text-left': first,
        'text-center': !first && !last,
        'text-right': last,
        'text-westetics-neutral-950 font-medium': i === currentStep,
        'text-neutral-400': i !== currentStep
      }"
      (click)="goTo(i)"
    >
      {{ step.label }}
    </span>
  </div>

  <!-- STEPPER -->
  <div class="flex items-center w-full relative">

    <ng-container *ngFor="let step of steps; let i = index">

      <!-- Bolinha -->
      <div class="relative z-10">
        <div
          class="w-[13px] h-[13px] rounded-full border flex items-center justify-center bg-white"
          [ngClass]="{
            'border-westetics-purple-600': i <= currentStep,
            'border-neutral-300': i > currentStep
          }"
        >
          <div
            *ngIf="i === currentStep"
            class="w-[5px] h-[5px] rounded-full bg-westetics-purple-600"
          ></div>
        </div>
      </div>

      <!-- Linha -->
      <div
        *ngIf="i < steps.length - 1"
        class="flex-1 h-px bg-neutral-300"
        [ngClass]="{
          'bg-westetics-purple-600': i < currentStep
        }"
      ></div>

    </ng-container>

  </div>

</div>
